import { overlay } from './overlay';

export const plugins = [overlay];
